module.exports = localforage;